import React from 'react';
import YouTubeIcon from 'assets/img/Youtube_play_icon.svg';
import './YoutubeLink.css';

const youtubeLink = () => {
  return (
    <div className="youtube-link">
      <a href="https://www.youtube.com/user/DTRandy/videos" target="_blank" rel="noopener noreferrer">
        <img className='video-image channel-image' src={YouTubeIcon} alt="YouTube link" />
        <span>Více najdete na našem YouTube kanálu!</span>
      </a>
    </div>
  );
}

export default youtubeLink;